import React, { useState, useEffect } from 'react'
import { Row, Col } from 'reactstrap';
import { TextField } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { MdAttachFile } from 'react-icons/md';
import { AiOutlinePaperClip, AiOutlineUpload } from 'react-icons/ai';

//Redux
import { connect } from 'react-redux';

//Funciones
// import { handleFilesAdd, deleteFile } from '../../../utils/azureStorage/upload';
import { singleFileUploader } from '../../../utils/FirebaseStorage/FirebaseStorage';

const mapStateToProps = state => ({
    usuarioActivo: state
})

let BodyUserSignature = (props) => {
    const [updFile, setUpdFile] = useState();
    const [searchEmail, setSearchEmail] = useState('');
    const [userId, setUserId] = useState(undefined);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));

    const FileUploader = () => {
        return (
            <div className={'FileUploader-style'}>
                <input type="file" id='uploadAssetsInput' onChange={(e) => { setUpdFile(e.target.files[0]) }} style={{ display: 'none' }} />
                <IconButton aria-label="Add" onClick={() => { document.getElementById('uploadAssetsInput').click() }}>
                    <AiOutlinePaperClip size={24} />
                </IconButton>
            </div>
        )
    }

    const handleUpload = async () => {
        try {
            if (userId === undefined || userId === '' || userId === null) {
                throw {
                    message: 'userId invalid'
                }
            }
            let newFile = await singleFileUploader(updFile, `signatures/${userId}/`, `${userId}.jpg`)
            props.toastSuccess('Archivo Cargado!')
        }
        catch (error) {
            console.log('error', error)
            props.toastError('Error al cargar archivo')
        }
    }

    return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='10' md='12' xs="12">
                        <TextField
                            required
                            key={`key_mail`}
                            id={`input_mail`}
                            fullWidth
                            label='Cédula'
                            margin="normal"
                            onChange={(e) => { setUserId(e.target.value) }}
                        />
                    </Col>
                    <Col lg='1' md='6' xs="6" className='user-mail-modal-footer'>
                        <FileUploader />
                    </Col>
                    <Col lg='1' md='6' xs="6" className='user-mail-modal-footer'>
                        <IconButton
                            disabled={(userId === undefined || userId === '' || userId === null || updFile === undefined || updFile === null)}
                            aria-label="Add"
                            onClick={() => { handleUpload() }}>
                            <AiOutlineUpload size={24} />
                        </IconButton>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
export default connect(mapStateToProps)(BodyUserSignature);